import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = ({ headerHeight = 0 }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    const scrollToTop = () => {
      // Scroll to top accounting for fixed headers
      window.scrollTo({ top: 0 - headerHeight, left: 0, behavior: "auto" });
    };

    // Try multiple ways to ensure scroll happens after page render
    const id = requestAnimationFrame(scrollToTop);
    const timeoutId = setTimeout(scrollToTop, 50); // fallback for slow rendering

    return () => {
      cancelAnimationFrame(id);
      clearTimeout(timeoutId);
    };
  }, [pathname, headerHeight]);

  return null;
};

export default ScrollToTop;
